import { Status } from "@/app/shared_enums/enums";
import { TableResponse } from "./shared_types";
export enum ReRouteType {
  WITHIN_DEPT = "within_department",
  ACROSS_DEPT = "across_department",
}

export interface Department {
  id?: number;
  name: string;
  org_id: number;
  logo?: string;
  status: Status;
  ticket_rerouting: ReRouteType;
  code: string;
  description?: string;
  person_name?: string;
  contact_person?: string;
  contact_number?: string;
}

export type DepartmentTable = TableResponse<Department>;
interface Schedule {
  day: string;
  opening_time: string; // ISO 8601 format
  closing_time: string; // ISO 8601 format
  ticket_end_time: string; // ISO 8601 format
}

export interface ServiceofDepartment {
  id: number;
  name: string;
  is_multi_step: boolean;
  schedule: Schedule[];
  img?:string
}

export interface KioskDepartmentServicesService {
  tag_id: number;
  name: string;
  code: string;
  status: string;
  type: string;
  event_id: number;
  org_id: number;
  path: number[];
  metadata: {
    key: string;
    value: {
      name: string;
      form_id: number | null;
      lead_id: number | null;
      country_code: string;
      contact_number: string | null;
      average_processing_time: number;
      max_tickets: number;
      visibility: string;
      status: boolean;
      logo: string | null;
      days_of_week: string[];
      apply_time_to_all_days: boolean;
      schedules: {
        day: string;
        opening_time: string;
        ticket_end_time: string;
        closing_time: string;
      }[];
      tags: string[];
    };
  }[];
  form_slug: string | null;
  created_at: string;
};
